<template>
  <v-dialog :value="value" :width="400" @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="py-1">
        <div class="headline">Share ref link</div>
        <v-btn icon left class="ml-auto" @click="$emit('input', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <div>
        <v-tabs :key="key" v-model="currentTab" centered slider-color="primary">
          <v-tab
            v-for="channel in availableChannels"
            :key="channel.value"
            :href="`#${channel.value}`"
            class="title"
          >
            <i :class="channel.icon"></i>
          </v-tab>
        </v-tabs>
        <v-divider />
      </div>
      <v-card-text>
        <v-textarea
          :value="url"
          outline
          single-line
          hide-details
          no-resize
          auto-grow
          :rows="1"
          readonly
        />
      </v-card-text>
      <v-card-actions class="justify-center">
        <CopyButton :text="url">
          <v-btn color="primary">
            {{ $t('copy') }}
          </v-btn>
        </CopyButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CopyButton from '@/components/elements/CopyButton.vue'
import { mapGetters } from 'vuex'

export default {
  components: { CopyButton },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    intent: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      currentTab: '',
      key: Date.now()
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    availableChannels() {
      return this.conversationSocialChannelOptions.filter(
        (channel) => channel.value === 'fb' || (channel.value === 'line' && this.intent.line_val)
      )
    },
    refValue() {
      if (!this.intent) return

      const { q_val = '' } = this.intent
      return decodeURI(
        encodeURIComponent(
          q_val
            .split(',')
            .map((question) => question.replace(/(?:includes|exacts)\((.*)\)/, '$1'))
            .filter((question) => !!question)[0]
        )
      )
    },
    url() {
      if (!this.refValue) return ''

      switch (this.currentTab) {
        case 'fb':
          return `https://m.me/${this.selectedBot.pageid}?ref=${this.refValue}`

        case 'line':
          return `https://line.me/R/oaMessage/${this.selectedBot.line_channel_id}?${this.refValue}`

        default:
          return ''
      }
    }
  },
  watch: {
    value(value) {
      if (value) {
        this.key = Date.now()
        if (this.availableChannels.length > 0) {
          this.currentTab = this.availableChannels[0].value
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/RefLinkDialog.vue